/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [vp.ApiResponse, (_params: vp.ELinxDeclineRequest) => void, () => void];

function usePostPaylinkDecline({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [params, setParams] = useState<vp.ELinxDeclineRequest>();
  const [response, setResponse] = useState<vp.ApiResponse>({
    Success: false,
    ErrorMessage: '',
  });
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const { t } = useTranslation('translations', { keyPrefix: 'Common' });
  useEffect(() => {
    const sendRequest = async (requestParams: vp.ELinxDeclineRequest) => {
      setDataFetchingInfo(true, `${t('defaultLoading')}`, 'fullScreen');

      const res = await api.postPaylinkDecline(requestParams, source);

      setResponse(res);
      if (res.Success) {
        sendJavaScriptMessage(requestParams);
      }
      setDataFetchingInfo(false);
      setSendRequest(false);
      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (_params: vp.ELinxDeclineRequest) => {
      setParams(_params);
      setSendRequest(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
      });
      setSendRequest(false);
    },
  ];
}

function sendJavaScriptMessage(requestParams: vp.ELinxDeclineRequest) {
  const Response = {
    ...requestParams,
    Step: 'ELINX_DECLINE',
  };
  window.top?.postMessage(Response, '*');
  if (window.parent && window.parent !== window.top) {
    window.parent.postMessage(Response, '*');
  }
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostPaylinkDecline);
